/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_OrdersInputs */

const en_cargos_sales_range_orders = /** @type {(inputs: Cargos_Sales_Range_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const es_cargos_sales_range_orders = /** @type {(inputs: Cargos_Sales_Range_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Cargos_Sales_Range_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_orders = /** @type {((inputs?: Cargos_Sales_Range_OrdersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_OrdersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_orders(inputs)
	return es_cargos_sales_range_orders(inputs)
});